@let userDetails = userDetails$ |async;

@if (userDetails && !inMobilePanel() && (visible$ | async)) {
  <tm-menubar-button [menuTrigger]="userMenu"
  [icon]="(icon$ | async) ?? ''" tooltip="Profile" i18n-tooltip="@@core.profile"></tm-menubar-button>
  <mat-menu #userMenu="matMenu" xPosition="after" yPosition="above" class="profile-menu">
    <button mat-menu-item (click)="showAbout()">
      <span i18n="@@core.profile.about">About</span>
    </button>
    @if (showLanguageToggle$ | async) {
      <tm-language-toggle></tm-language-toggle>
    }
    @if (userDetails.isAuthenticated && userDetails.username) {
      <button class="logged-in-as" mat-menu-item disabled>
        <span i18n="@@core.profile.logged-in-as">Logged in as</span>
        <span>{{' '}}{{userDetails.username}}</span>
      </button>
    }
    @if ((userIsAdmin$ | async) && !inMobilePanel()) {
      <button mat-menu-item routerLink="/admin">
        <span i18n="@@core.profile.go-to-admin">Go to admin</span>
      </button>
    }
    @if (userDetails.isAuthenticated && userDetails.username) {
      <button mat-menu-item (click)="logout()">
        <span i18n="@@core.profile.logout">Logout</span>
      </button>
    }
    @if (showLoginButton$ | async) {
      @if (!userDetails.isAuthenticated) {
        <button mat-menu-item (click)="login()">
          <span i18n="@@core.profile.login">Login</span>
        </button>
      }
    }
  </mat-menu>
} @else if (userDetails && (visible$ | async)) {
  <button mat-menu-item (click)="showAbout()">
    <span i18n="@@core.profile.about">About</span>
  </button>
  @if (showLanguageToggle$ | async) {
    <tm-language-toggle></tm-language-toggle>
  }
  @if (userDetails.isAuthenticated && userDetails.username) {
    <button class="logged-in-as" mat-menu-item disabled>
      <span i18n="@@core.profile.logged-in-as">Logged in as</span>
      <span>{{' '}}{{userDetails.username}}</span>
    </button>
  }
  @if ((userIsAdmin$ | async) && !inMobilePanel()) {
    <button mat-menu-item routerLink="/admin">
      <span i18n="@@core.profile.go-to-admin">Go to admin</span>
    </button>
  }
  @if (userDetails.isAuthenticated && userDetails.username) {
    <button mat-menu-item (click)="logout()">
      <span i18n="@@core.profile.logout">Logout</span>
    </button>
  }
  @if (showLoginButton$ | async) {
    @if (!userDetails.isAuthenticated) {
      <button mat-menu-item (click)="login()">
        <span i18n="@@core.profile.login">Login</span>
      </button>
    }
  }
}
